import { useQuery } from '@tanstack/react-query';

import { getProjectContractors } from '@/features/projects/shared/api/get-project-contractors';
import { ProjectType } from '@/shared/types/api';

export const useProjectContractors = ({
  projectId,
  type,
}: {
  projectId?: number;
  type?: ProjectType;
}) => {
  return useQuery({
    queryKey: ['project-contractors', projectId, type],
    queryFn: () =>
      getProjectContractors({ projectId: projectId!, type: type! }),
    enabled: !!projectId && !!type,
  });
};
